/**
 * Derives the current set of feature flags from an app configuration object.
 * Use this as the single source of truth for flag evaluation across all environments.
 */
export const getFeatureFlags = (config, { aiFeaturesEnabled }) => {
    const aiFeatures = aiFeaturesEnabled && config?.premium?.aiFeatures === true;
    return {
        aiFeatures,
        sentimentAnalysis: aiFeatures && config?.surveys?.sentimentAnalysis === true,
        aiGenerationModePicker: aiFeatures && config?.surveys?.aiGenerationModePicker === true,
        aiRecentRespondentDocuments: aiFeatures && config?.surveys?.aiRecentRespondentDocuments === true,
        respondentConfirmationNotifications: config?.premium?.respondentConfirmationNotifications === true,
        nextAvailableBookings: config?.premium?.nextAvailableBookings === true,
        companies: config?.others?.companies === true,
    };
};
//# sourceMappingURL=featureFlags.js.map